var footerOnSubmit = function(e){
  e.preventDefault();
  e.stopImmediatePropagation();

  var form = this;
  var error = false;
  var errorMsg = form.querySelector('.error-msg');

  errorMsg.style.display = 'none';
  form.querySelectorAll('.error').forEach((elem)=>{
    elem.classList.remove('error');
  });
  form.querySelectorAll('.required').forEach((elem)=>{
    if(elem.value=="") {
      error = true;
      elem.classList.add('error');
    }
  });
  if(error) {
    errorMsg.innerHTML = 'Please complete all the required fields.';
    errorMsg.style.display = 'block';
  } else {
    if(!$s.validateEmail(form.querySelector('.email').value)) {
      error = true;
      form.querySelector('.email').classList.add('error');
      errorMsg.style.display = 'block';
      errorMsg.innerHTML = 'Please provide a valid email address.';
    }
  }
  if(!error) {
    $s.post({url: form.dataset['ajax-submit'],data: new FormData(form),
      success: function(){
        form.querySelector('.form-wrap').style.display = 'none';
        form.querySelector('.success-msg').style.display = 'block';
      },
      error: function(){
        form.removeEventListener('submit', footerOnSubmit);
        form.submit();
      }
    });
  }
}
var formEl = document.getElementById('footer').querySelector('form');
if (formEl) addEventListener('submit', footerOnSubmit);

document.querySelectorAll('.s4com-articles > a').forEach(function(el){
  el.addEventListener('click', function() {
      window.scrollTo({
          top: this.offsetTop - 100,
          behavior: "smooth"
      });
  });
});